import styles from './TournamentDetailsRow.module.css';
import { ReactNode } from 'react';

type Props = {
  title: ReactNode;
  tags: ReactNode;
  date: ReactNode;
  statement: ReactNode;
  link: ReactNode;
};

export function TournamentDetailsRow({
  title,
  tags,
  date,
  statement,
  link,
}: Props) {
  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      <div className={styles.tags}>{tags}</div>
      <div className={styles.filler} />
      <div className={styles.date}>{date}</div>
      <div className={styles.actions}>
        <div className={styles.statement}>{statement}</div>
        <div className={styles.link}>{link}</div>
      </div>
    </div>
  );
}
